const initialState = {
  eventList: [],
  businessConfig: {},
  upcomingEvents: [],
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch(type) {
  case 'ADMIN_PRIMARY_ORGANIZERS_EDIT:DATA:SET':
    return {
      ...state,
      eventList: data,
    };
  case 'ADMIN_PRIMARY_ORGANIZERS_EDIT:BUSINESS_CONFIG:SET':
    return {
      ...state,
      businessConfig: data,
    };
  case 'ADMIN_PRIMARY_ORGANIZERS_EDIT:UPCOMING_EVENTS:SET':
    return {
      ...state,
      upcomingEvents: data,
    };
  default:
    return state;
  }
}